module.exports = __webpack_public_path__ + "static/media/lock-open.978270d9.svg";